module.exports = __webpack_public_path__ + "img/68_49.c4ed4984.png";